<template>
  <div class="table-responsive" style="overflow: hidden;">
    <div class=" table mb-0 col-xs-12 p-0">
      <table class="w-100">
        <tbody>
           <tr>
            <td
              class="d-flex align-items-center p-0 mb-2"
              style="border: none !important;"
            >
              <p
                class="mb-0 col-md-7 pl-0 pr-2 text-nowrap"
                style="color: #fc6075;"
                title="Talent Search - HR Management"
              >
                Application Management - HR Management
              </p>
              <strong
                class="col-md-5 pr-0 pl-2 text-nowrap"
                title="Completed in 3 Years"
                >Active</strong
              >
            </td>
          </tr>
          <tr>
            <td
              class="d-flex align-items-center p-0 mb-2"
              style="border: none !important;"
            >
              <p
                class="mb-0 col-md-7 pl-0 pr-2 text-nowrap"
                style="color: #fc6075;"
                title="Set Search Criteria Stage"
              >
                5: Contract Negotiation
              </p>
              <strong class="col-md-7 pr-0 pl-2">{{app.status > 5 ? 'Completed' : (app.status == 5) ?'Active' : 'Inactive'}}</strong>
            </td>
          </tr>
              <tr v-if="app.vacancy.vacancysettings.expectedResumptionDate">
                <td class="d-flex align-items-center p-0 mb-2 mt-3">
                  <p class="mb-0 col-md-7 pl-0 pr-2"><i class="la la-check"></i>Resumption Date</p>
                  <div class="col-md-5 pr-0 pl-2 custom-control">
                  <input
                    type="date"
                    class="form-control"
                    v-model="app.applicationNegotiation.expectedResumptionDate"
                  />
                  </div>
                </td>
              </tr>
          <tr v-if="app.vacancy.vacancysettings.expectedSalary">
                <td class="d-flex align-items-center p-0 mb-2">
                  <p class="mb-0 col-md-7 pl-0 pr-2"><i class="pr-3"></i>Salary</p>
                  <div class="col-md-5 pr-0 pl-2 custom-control">
                  <input
                    type="text"
                    class="form-control"
                    v-model="app.applicationNegotiation.negotiatedSalary"
                  /></div>
                </td>
              </tr>
              <tr v-if="app.vacancy.vacancysettings.rank">
                <td class="d-flex align-items-center p-0 mb-2">
                  <p class="mb-0 col-md-7 pl-0 pr-2"><i class="pr-3"></i>Rank</p>
                  <div class="col-md-5 pr-0 pl-2 custom-control">
                  <select class="form-control" v-model="app.applicationNegotiation.rank">
                      <option selected>Select Rank</option>
                      <option
                        v-for="rank in ranks"
                        :key="rank.id"
                        :value="rank.rankName"
                      >
                        {{ rank.rankName }}
                      </option>
                    </select></div>
                </td>
              </tr>
              <tr v-if="app.vacancy.vacancysettings.probationPeriod">
                <td class="d-flex align-items-center p-0 mb-2">
                  <p class="mb-0 col-md-7 pl-0 pr-2"><i class="pr-3"></i>Probation Period</p>
                  <div class="col-md-5 pr-0 pl-2 custom-control">
                  <select class="form-control" v-model="app.applicationNegotiation.probationPeriod">
                      <option selected>No Probation</option>
                      <option>1 month</option>
                      <option>2 months</option>
                      <option>3 months</option>
                      <option>4 months</option>
                      <option>5 months</option>
                      <option>6 months</option>
                      <option>7 months</option>
                      <option>8 months</option>
                      <option>9 months</option>
                      <option>10 months</option>
                      <option>11 months</option>
                      <option>1 year</option>
                    </select></div>
                </td>
              </tr>
              <tr v-if="app.vacancy.vacancysettings.reportingTo">
                <td class="d-flex align-items-center p-0 mb-2">
                  <p class="mb-0 col-md-7 pl-0 pr-2"><i class="pr-3"></i>Reporting To</p>
                  <div class="col-md-5 pr-0 pl-2 custom-control">
                  <select class="form-control" v-model="app.applicationNegotiation.reportingTo">
                      <option selected>Select Staff</option>
                      <option
                        v-for="member in employees"
                        :key="member.id"
                        :value="member.lastName + ' ' + member.firstName"
                      >
                        {{ member.lastName + " " + member.firstName }}
                      </option>
                    </select></div>
                </td>
              </tr>
        </tbody>
      </table>
    </div>
    <button v-if="(app.status == 5 && app.applicationNegotiation.status == 0)" type="button" class="btn btn-primary btn-lg btn-block mt-5" style="border-radius: 0" @click="action">Send offer <i class="la la-angle-right ml-2"></i></button>
  </div>
</template>

<script>
import { organizationService } from "@/services/organizationService";
import { employeeService } from "@/services/employeeService";
export default {
  name: "applications-timeline-two",
  props: {
    action: { type: Function },
         app: {},
         currentOffice: {}
      },
  data() {
    return {
      relatedTasksCompleted: true,
      negotiationsCompleted: true,
    };
  },
  mounted() {
    this.getRanks()
    this.getEmployees()
  },
  methods: {
    getRanks() {
      organizationService.getRanks().then((o) => {
        this.ranks = o;
      });
    },
    getEmployees() {
      employeeService.getEmployees(this.currentOffice.id).then(
        (model) => {
          this.employees = model;
          // console.log(model);
        },
        (error) => {
          error = error;
        }
      );
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/applications/applications-timeline-six.vue